import { EquityTier, LeadGuidance } from './guidance';

const NO_GATE = {
  gateRequired: false,
  gateDecision: null,
  buyout: null,
  finishLeasePaymentsLeft: null,
  sellNowNet: null,
  monthlyPayment: null,
  remainingMonths: null,
} as const;

export type DevGuidanceScenario =
  | EquityTier
  | 'deep_negative_two_way'
  | 'parked_buyout'
  | 'parked_finish_lease';

export const DEV_GUIDANCE_SAMPLES: Record<DevGuidanceScenario, LeadGuidance> = {
  silent: {
    tier: 'silent',
    equityRange: { low: 4800, high: 7200 },
    mileageOverageEstimate: null,
    payoffVerified: true,
    ...NO_GATE,
  },
  thin_positive: {
    tier: 'thin_positive',
    equityRange: { low: 1500, high: 2900 },
    mileageOverageEstimate: null,
    payoffVerified: true,
    ...NO_GATE,
  },
  negative: {
    tier: 'negative',
    equityRange: { low: -1800, high: -1100 },
    mileageOverageEstimate: 780,
    payoffVerified: true,
    ...NO_GATE,
  },
  deep_negative: {
    tier: 'deep_negative',
    equityRange: { low: -18300, high: -15600 },
    mileageOverageEstimate: null,
    gateRequired: true,
    gateDecision: null,
    payoffVerified: true,
    buyout: { payoff: 41900, taxAndFees: 2664, premium: 16264, premiumOverCap: true },
    finishLeasePaymentsLeft: 7860,
    sellNowNet: -17000,
    monthlyPayment: 655,
    remainingMonths: 12,
  },
  deep_negative_two_way: {
    tier: 'deep_negative',
    equityRange: { low: -7500, high: -5300 },
    mileageOverageEstimate: null,
    gateRequired: true,
    gateDecision: null,
    payoffVerified: true,
    buyout: { payoff: 31050, taxAndFees: 2013, premium: 4813, premiumOverCap: false },
    finishLeasePaymentsLeft: null,
    sellNowNet: -6200,
    monthlyPayment: null,
    remainingMonths: null,
  },
  parked_buyout: {
    tier: 'deep_negative',
    equityRange: { low: -7500, high: -5300 },
    mileageOverageEstimate: null,
    gateRequired: true,
    gateDecision: 'buyout',
    payoffVerified: true,
    buyout: { payoff: 32600, taxAndFees: 1956, premium: 4813, premiumOverCap: false },
    finishLeasePaymentsLeft: null,
    sellNowNet: -6200,
    monthlyPayment: null,
    remainingMonths: null,
  },
  parked_finish_lease: {
    tier: 'deep_negative',
    equityRange: { low: -18300, high: -15600 },
    mileageOverageEstimate: null,
    gateRequired: true,
    gateDecision: 'finish_lease',
    payoffVerified: true,
    buyout: { payoff: 41900, taxAndFees: 2664, premium: 16264, premiumOverCap: true },
    finishLeasePaymentsLeft: 7860,
    sellNowNet: -17000,
    monthlyPayment: 655,
    remainingMonths: 12,
  },
};
